(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[120],{

/***/ 3676:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ Footer; }
});

// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(5988);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(1720);
// EXTERNAL MODULE: ./src/components/blocks/gradient-block.tsx
var gradient_block = __webpack_require__(6737);
// EXTERNAL MODULE: ./src/components/footer/primary-nav.tsx
var primary_nav = __webpack_require__(4942);
// EXTERNAL MODULE: ./src/components/trans-link.tsx
var trans_link = __webpack_require__(2331);
// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(7997);
;// CONCATENATED MODULE: ./src/components/footer/secondary-nav.tsx

 // eslint-disable-next-line import/no-internal-modules




function SecondaryNav(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime/* jsxs */.BX)("nav", {
    className: "jsx-1874299308" + " " + "secondary",
    children: [data.map(renderLink), /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(style["default"], {
      id: "1874299308",
      children: [".secondary.jsx-1874299308{text-align:right;}"]
    })]
  });

  function renderLink(_ref2) {
    var title = _ref2.title,
        href = _ref2.href;
    return /*#__PURE__*/(0,jsx_runtime/* jsxs */.BX)(compat_module.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(trans_link/* TransLink */.H, {
        href: href,
        className: className + ' ',
        children: title
      }), styles]
    }, href);
  }
}
var _styles$className = {
  styles: /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(style["default"], {
    id: "2225481763",
    children: ["a.jsx-2225481763{font-size:0.65rem !important;margin-left:0.4rem;border-bottom-width:0 !important;}", "a.jsx-2225481763:hover{border-bottom:1px solid black !important;}"]
  }),
  className: "jsx-2225481763"
},
    className = _styles$className.className,
    styles = _styles$className.styles;
;// CONCATENATED MODULE: ./src/components/footer/footer.tsx









function Footer(_ref) {
  var data = _ref.data;

  var _useState = (0,compat_module.useState)(false),
      showFullMail = _useState[0],
      setShowFullMail = _useState[1];

  var router = (0,next_router.useRouter)();
  var route = router.asPath.split('#')[0];
  var showContact = route === '/' || route === '/verlag';
  (0,compat_module.useEffect)(function () {
    if (!showContact) return;
    setShowFullMail(true);
  }, [showContact]);
  return /*#__PURE__*/(0,jsx_runtime/* jsxs */.BX)("footer", {
    id: "contact",
    children: [showContact ? /*#__PURE__*/(0,jsx_runtime/* jsxs */.BX)("div", {
      className: "jsx-3957130285" + " " + "serif",
      children: ["Wittendoerfer Verlagsgesellschaft", /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)("br", {
        className: "jsx-3957130285"
      }), "Hohenzollernstra\xDFe 122", /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)("br", {
        className: "jsx-3957130285"
      }), "80796 M\xFCnchen", /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)("br", {
        className: "jsx-3957130285"
      }), showFullMail ? /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)("a", {
        href: "mailto:as@wittendoerfer.de",
        className: "jsx-3957130285",
        children: "as@wittendoerfer.de"
      }) : /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)("p", {
        className: "jsx-3957130285",
        children: "as &at& wittendoerfer &dot& de"
      }), /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(style["default"], {
        id: "3957130285",
        children: ["div.jsx-3957130285{margin-top:9rem;}", "@media (min-width:680px){div.jsx-3957130285{-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;}}"]
      }), /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(gradient_block/* GradientBlock */.u, {
        height: "30"
      })]
    }) : null, /*#__PURE__*/(0,jsx_runtime/* jsxs */.BX)("div", {
      className: "jsx-1865803137",
      children: [/*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(trans_link/* TransLink */.H, {
        href: "/",
        className: "no-under",
        children: /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)("img", {
          src: "/_assets/wittendoerfer-logo-sm.svg",
          alt: "Wittendoerfer Logo small",
          width: "96",
          height: "8.5",
          className: "jsx-1865803137"
        })
      }), /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(primary_nav/* PrimaryNav */.s, {
        data: data.primaryMenu
      }), /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(style["default"], {
        id: "1865803137",
        children: ["img.jsx-1865803137{width:8rem;height:3rem;}", "div.jsx-1865803137{margin-top:5rem;text-align:right;}", "@media (min-width:780px){div.jsx-1865803137{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;}}"]
      })]
    }), /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(SecondaryNav, {
      data: data.secondaryMenu
    })]
  });
}

/***/ }),

/***/ 5283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5988);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1720);
/* harmony import */ var _components_trans_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2331);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7997);






function Header(_ref) {
  var small = _ref.small;
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var hash = window.location.hash;
    window.location.hash = '';
    window.location.hash = hash;
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .Fragment */ .HY, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)("header", {
      className: "jsx-2811202022 " + styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__["default"].dynamic([["973127653", [small ? '1rem' : '4rem']]]) + " " + "logo",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_components_trans_link__WEBPACK_IMPORTED_MODULE_2__/* .TransLink */ .H, {
        href: "/",
        className: "no-under",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("img", {
          src: "/_assets/wittendoerfer-logo".concat(small ? '-sm' : '', ".svg"),
          alt: "Wittendoerfer Logo",
          width: small ? '110' : '368',
          height: "36",
          className: "jsx-2811202022 " + styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__["default"].dynamic([["973127653", [small ? '1rem' : '4rem']]])
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__["default"], {
        id: "2811202022",
        children: [".logo.jsx-2811202022{max-width:20rem;margin-bottom:1.5rem;padding-bottom:0;}", ".logo.jsx-2811202022 img.jsx-2811202022{max-width:100%;height:auto;}"]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__["default"], {
        id: "973127653",
        dynamic: [small ? '1rem' : '4rem'],
        children: [".logo.__jsx-style-dynamic-selector{margin-top:".concat(small ? '1rem' : '4rem', ";}")]
      })]
    })
  });
}

/***/ }),

/***/ 3755:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ PageSlug; }
});

// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(5988);
// EXTERNAL MODULE: ./src/components/blocks/page-blocks.tsx + 6 modules
var page_blocks = __webpack_require__(1994);
// EXTERNAL MODULE: ./src/components/footer/footer.tsx + 1 modules
var footer = __webpack_require__(3676);
// EXTERNAL MODULE: ./src/components/header/header.tsx
var header = __webpack_require__(5283);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(1720);
// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(7997);
;// CONCATENATED MODULE: ./src/components/header/you-can-scroll-you-know.tsx




function YouCanScrollYouKnow() {
  var _useState = (0,compat_module.useState)(false),
      show = _useState[0],
      setShow = _useState[1];

  function isScrolled() {
    return window.scrollY > 100;
  }

  function isReallyScrolled() {
    return window.scrollY > 500;
  }

  (0,compat_module.useEffect)(function () {
    // not scrolled after some seconds: show
    setTimeout(function () {
      if (!isScrolled()) {
        setShow(true);
      }
    }, 3000);
  });
  (0,compat_module.useEffect)(function () {
    if (!show) return; // hide if scrolled

    window.addEventListener('scroll', handleScroll);
    return function cleanupListener() {
      window.removeEventListener('scroll', handleScroll);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  function handleScroll() {
    if (isReallyScrolled()) {
      setShow(false);
      window.removeEventListener('scroll', handleScroll);
    }
  }

  function clickHandler() {
    var _afterTitle$firstElem, _afterTitle$firstElem2;

    setShow(false);
    var title = document.getElementById('page-title');
    var afterTitle = document.getElementById('after-title'); //second child of content container. will probably break in the future ^^

    var secondChildHack = afterTitle === null || afterTitle === void 0 ? void 0 : (_afterTitle$firstElem = afterTitle.firstElementChild) === null || _afterTitle$firstElem === void 0 ? void 0 : (_afterTitle$firstElem2 = _afterTitle$firstElem.firstElementChild) === null || _afterTitle$firstElem2 === void 0 ? void 0 : _afterTitle$firstElem2.nextElementSibling;
    var scrollTarget = title ? afterTitle : secondChildHack;
    if (scrollTarget) scrollTarget === null || scrollTarget === void 0 ? void 0 : scrollTarget.scrollIntoView({
      behavior: 'smooth'
    });else window.scroll({
      top: 700,
      behavior: 'smooth'
    });
  }

  return /*#__PURE__*/(0,jsx_runtime/* jsxs */.BX)("a", {
    title: "Zum Inhalt",
    onClick: clickHandler,
    className: "jsx-3325228843" + " " + ('you-can-scroll-you-know ' + (show ? 'show' : 'hide') || 0),
    children: ["\u261F", /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(style["default"], {
      id: "3325228843",
      children: ["a.you-can-scroll-you-know.jsx-3325228843{position:fixed;right:2rem;top:3.7rem;background-color:var(--brand-light);width:5rem;height:5rem;color:#fff;font-size:3.5rem;text-align:center;border-bottom:0;cursor:pointer;opacity:0;pointer-events:none;-webkit-transition:opacity 0.7s ease-in !important;transition:opacity 0.7s ease-in !important;}", "a.you-can-scroll-you-know.show.jsx-3325228843{opacity:1;pointer-events:all;-webkit-transition:opacity 4s !important;transition:opacity 4s !important;}"]
    })]
  });
}
;// CONCATENATED MODULE: ./src/pages/[[...slug]].tsx







var __N_SSG = true;
function PageSlug(props) {
  var _data$config, _data$images;

  if (!props || props == {}) return null;
  var _ref = props,
      data = _ref.data,
      menuData = _ref.menuData,
      books = _ref.books,
      authors = _ref.authors;
  var hasColums = (_data$config = data.config) !== null && _data$config !== void 0 && _data$config.forceColumns ? true : (_data$images = data.images) === null || _data$images === void 0 ? void 0 : _data$images.length;
  return /*#__PURE__*/(0,jsx_runtime/* jsxs */.BX)("div", {
    id: "page-".concat(data.slug),
    className: "jsx-1417194127",
    children: [/*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(header/* Header */.h, {}), data.slug === 'index' ? /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(YouCanScrollYouKnow, {}) : null, renderTitle(), /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)("main", {
      className: "jsx-1417194127",
      children: /*#__PURE__*/(0,jsx_runtime/* jsxs */.BX)("div", {
        id: "after-title",
        className: "jsx-1417194127" + " " + "after-title serif ".concat(hasColums ? 'columns' : ''),
        children: [/*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)("div", {
          className: "jsx-1417194127" + " " + "content",
          children: /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(page_blocks/* PageBlocks */.a, {
            blocks: data.blocks,
            books: books,
            authors: authors
          })
        }), /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)("div", {
          className: "jsx-1417194127" + " " + "image-space",
          children: /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(page_blocks/* PageBlocks */.a, {
            blocks: data.images
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(style["default"], {
      id: "1417194127",
      children: ["h2.jsx-1417194127{margin-top:54vh;}", ".after-title.jsx-1417194127{margin-top:8rem;}", "@media (min-width:780px){.after-title.columns.jsx-1417194127{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;}.after-title.columns.jsx-1417194127 .content.jsx-1417194127{width:47%;max-width:47%;}.after-title.columns.jsx-1417194127 .spacer.jsx-1417194127,.after-title.columns.jsx-1417194127 .image-space.jsx-1417194127{width:47%;max-width:47%;}}"]
    }), /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(footer/* Footer */.$, {
      data: menuData
    })]
  });

  function renderTitle() {
    var _data$config2;

    if ((_data$config2 = data.config) !== null && _data$config2 !== void 0 && _data$config2.hideTitle) return null;
    return /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)("h1", {
      id: "page-title",
      style: {
        marginTop: '45vh',
        paddingBottom: '1rem'
      },
      children: data.title
    });
  }
}

/***/ }),

/***/ 8150:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[[...slug]]",
      function () {
        return __webpack_require__(3755);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [871,282,888,179], function() { return __webpack_exec__(8150); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);